module.exports = __webpack_public_path__ + "static/media/cert_2.14b473dd.jpg";